import React, { useState, useEffect } from 'react';
import HeaderComponent from '../components/General/HeaderComponent';
import ProfileComponent from '../components/ProfileComponent';
import ProfileCardComponent from '../components/ProfileCardComponent';
import { getProfile, updateGeneral, uploadAvatar } from '../services/profile';
import Notiflix from 'notiflix';

export default function Profile() {
  const [userData, setUserData] = useState({});
  const [form, setForm] = useState({ ufname: '', ulname: '', uwork: '', ulocation: '' });
  const [avatarFile, setAvatarFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [activeTab, setActiveTab] = useState('general');

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getProfile();
        setUserData(data);
        setForm({
          ufname: data.ufname || '',
          ulname: data.ulname || '',
          uwork: data.uwork || '',
          ulocation: data.ulocation || ''
        });
      } catch (error) {
        console.error('Profil verisi yüklenirken hata:', error);
        Notiflix.Notify.failure('Profil alınamadı');
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      if (!form.ufname) {
        Notiflix.Notify.warning('Ad alanı zorunludur');
        return;
      }
      const updated = await updateGeneral({ 
        ufname: form.ufname, 
        ulname: form.ulname, 
        uwork: form.uwork 
      });
      setUserData((prev) => ({ ...prev, ...updated }));
      Notiflix.Notify.success('Genel bilgiler başarıyla güncellendi');
    } catch (error) {
      if (error?.response?.status === 422) {
        Notiflix.Notify.failure('Validasyon hatası: Ad zorunludur');
      } else if (error?.response?.status === 401) {
        Notiflix.Notify.failure('Yetkisiz işlem. Lütfen tekrar giriş yapın.');
      } else {
        Notiflix.Notify.failure('Güncelleme başarısız. Lütfen tekrar deneyin.');
      }
    }
  };

  const handleAvatarUpload = async () => {
    try {
      if (!avatarFile) {
        Notiflix.Notify.warning('Lütfen bir görsel seçin');
        return;
      }
      setIsUploading(true);
      const res = await uploadAvatar(avatarFile);
      // Yeni dokümana göre uimg ve url tam S3 URL olarak gelir
      const imageUrl = res?.uimg || res?.url;
      if (imageUrl) {
        setUserData((prev) => ({ ...prev, uimg: imageUrl, uimgtype: 'png' }));
      }
      setAvatarFile(null);
      Notiflix.Notify.success('Avatar başarıyla yüklendi');
    } catch (error) {
      if (error?.response?.status === 413) {
        Notiflix.Notify.failure('Dosya çok büyük (maksimum 1MB)');
      } else if (error?.response?.status === 400) {
        Notiflix.Notify.failure('Geçersiz dosya türü. Sadece JPG, JPEG ve PNG desteklenir.');
      } else {
        Notiflix.Notify.failure('Yükleme başarısız. Lütfen tekrar deneyin.');
      }
    } finally {
      setIsUploading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full h-screen flex justify-center items-center dark:bg-dark-100">
        <img src="/assets/penalogo.svg" alt="Yükleniyor..." width="200" height="200" className="animate-pulse" />
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen dark:bg-dark-100 bg-stone-100 transition duration-300">
      <div className="container mx-auto px-4 py-6">
        <HeaderComponent title="Profil" />
        
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
          {/* Sol Menü - ProfileComponent */}
          <div className="lg:col-span-1">
            <ProfileComponent 
              user={userData} 
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />
          </div>
          
          {/* Sağ İçerik - ProfileCardComponent */}
          <div className="lg:col-span-3">
            {activeTab === 'general' && (
              <ProfileCardComponent
                user={userData}
                form={form}
                onChange={(e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
                onSave={handleSave}
                avatarFile={avatarFile}
                onAvatarChange={(e) => setAvatarFile(e.target.files?.[0] || null)}
                onUploadAvatar={handleAvatarUpload}
                isUploading={isUploading}
              />
            )}
            
            {activeTab !== 'general' && (
              <div className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 rounded-lg p-8 text-center">
                <p className="text-gray-500 dark:text-darkWhite-200">
                  {activeTab === 'connections' && 'Bağlantılar özelliği yakında eklenecektir.'}
                  {activeTab === 'organizations' && 'Firmalarım özelliği yakında eklenecektir.'}
                  {activeTab === 'security' && 'Güvenlik ayarları yakında eklenecektir.'}
                  {activeTab === 'badges' && 'Rozetlerim özelliği yakında eklenecektir.'}
                  {activeTab === 'settings' && 'Genel ayarlar yakında eklenecektir.'}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}